export default jogadores => {
  try {
    let contagem = 0;
    let limite = 8;
    const grupos = [];
    const gruposTela = [
      { grupos: [], jogadores: [] },
      { grupos: [], jogadores: [] },
    ];
    // Separar por categoria em ordem decrescente
    const categorias = [];
    jogadores.map(jogador => {
      if (!categorias.includes(jogador.categoria)) categorias.push(jogador.categoria);
      return null;
    });
    categorias.sort((a, b) => {
      if (b > a) {
        return -1;
      } else {
        return 1;
      }
    });
    // ------------------------------------------
    // Aumenta o limite de jogadores para a categoria C
    if (categorias[0] === 'C') {
      limite = 8;
    }
    // ------------------------------------------
    const jogadoresOrdem = jogadores.filter(jog => jog.categoria === categorias[0]);
    jogadoresOrdem.sort((a, b) => a.idGrupo - b.idGrupo);
    jogadoresOrdem.map(jogador => {
      const index = grupos.findIndex(grupo => grupo.id === jogador.idGrupo);
      if (index < 0) {
        grupos.push({ id: jogador.idGrupo, nomeGrupo: jogador.nomeGrupo, qtde: 1 });
      } else {
        grupos[index].qtde++;
      }
      return null;
    });
    for (const grupo of grupos) {
      if (contagem >= 0) {
        contagem += grupo.qtde;
        if (contagem <= limite) {
          gruposTela[0].grupos.push(grupo.nomeGrupo);
          gruposTela[0].jogadores.push(...jogadoresOrdem.filter(jogador => jogador.idGrupo === grupo.id));
        } else if (contagem > limite) {
          gruposTela[1].grupos.push(grupo.nomeGrupo);
          gruposTela[1].jogadores.push(...jogadoresOrdem.filter(jogador => jogador.idGrupo === grupo.id));
          contagem = -1;
        }
      }
    }
    return gruposTela;
  } catch (e) {
    console.log(e);
    return [];
  }
};
